import {connect} from 'react-redux';
import {List} from 'immutable';
import moment from 'moment';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../../state/schema';
import {
  loadCity,
  updateCity,
  createCity,
  deleteCity,
  cityFormDestroy
} from '../../../../../../state/modules/locationCities/actions';
import {sendMessage} from '../../../../../../state/actions';
import CityForm from '../components/CityForm';
import Config from '../../../../../../Config';

const inputs = List([
  'name',
  'region',
  'subregion',
  'status'
]);

const mapStateToProps = (state, ownProps) => {

  const city = denormalize(
    state.entities.getIn(['cities', ownProps.id]),
    schema.city,
    state.entities.toJS()
  );

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['cities', ownProps.id, val], '');
    errors[val] = state.locationCities.getIn(['form', 'errors', val]);
  }
  data['country'] = city && city.region.country ? city.region.country.id.toString() : null;
  data['region'] = city && city.region ? city.region.id.toString() : null;
  data['subregion'] = city && city.subregion ? city.subregion.id.toString() : null;
  Object.keys(data).forEach(x => {
    if (['status', 'rating'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  data['published_at'] = data['published_at']
    ? moment(data['published_at'], Config.get('API_DATETIME_FORMAT'))
    : moment();

  data['edited_at'] = data['edited_at']
    ? moment(data['edited_at'], Config.get('API_DATETIME_FORMAT'))
    : null;

  if (data['tags'] === '') {
    data['tags'] = [];
  }

  if (data['media'] === '') {
    data['media'] = [];
  }

  return {
    isLoading: state.locationCities.get('areCitiesLoading'),
    isSubmitting: state.locationCities.getIn(['form', 'isSubmitting']),
    success: state.locationCities.getIn(['form', 'success']),
    created_id: state.locationCities.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['cities', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['cities', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadCity(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateCity(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createCity(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deleteCity(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(cityFormDestroy(formState));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const CityFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CityForm);

export default CityFormContainer;
